import React from 'react';
import PropTypes from 'prop-types';

import './text-area.scss';

const TextArea = props => {
  const { value, name, placeholder, onChange } = props;

  return (
    <div className="text-area">
      <div className="input">
        <textarea name={name} value={value} placeholder={placeholder} onChange={onChange} />
      </div>
    </div>
  );
};

TextArea.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  labelType: PropTypes.oneOf(['horizontal', 'vertical']),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

TextArea.defaultProps = {
  value: null,
  label: '',
  labelType: 'vertical',
  subLabel: '',
  placeholder: '',
  required: false,
};

export default TextArea;
